import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import MarvinLightbulb from '@/components/svg/marvin-lightbulb.svg?inline';
import MarvinLightbulbRelaxed from '@/components/svg/marvin/MarvinLightbulbRelaxed.svg?inline';
import MarvinSad from '@/components/svg/marvin/marvin_sad.svg?inline';
import MarvinAlarm from '@/components/svg/marvin/marvin_alarm.svg?inline';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarvinInfoBox',
  props: {
  text: {
    type: String,
    default: ''
  },
  mood: {
    type: String,
    default: 'relaxed'
  },
  type: {
    type: String as PropType<'infobox' | 'confirm'>,
    default: 'infobox'
  }
},
  setup(__props) {

const props = __props;



const MarvinType = computed(() => {
  switch (props.mood) {
    case 'alarm':
      return MarvinAlarm;
    case 'concerned':
      return MarvinLightbulb;
    case 'veryConcerned':
      return MarvinSad;
    case 'relaxed':
      return MarvinLightbulbRelaxed;
    default:
      return MarvinLightbulbRelaxed;
  }
});

return { __sfc: true,props, MarvinType, BCXMarkdown }
}

})